import type { CmsOverlayClientRuntime } from './runtime-registry-contract';
import type {
  CmsGlobalOverlayState,
  CmsLoadedGlobalOverlayState,
  CmsOverlayRenderModel,
  CmsOverlayTriggerPayload,
} from './types';

export function createCmsGlobalOverlayState(params: {
  model: CmsOverlayRenderModel;
  payload?: CmsOverlayTriggerPayload;
  runtime: CmsOverlayClientRuntime;
}): CmsLoadedGlobalOverlayState {
  const state = params.runtime.createState(params);
  if (!state) {
    throw new Error(
      `CMS overlay "${params.model.id}" failed to create ${params.model.type} state.`
    );
  }

  return {
    ...state,
    runtime: params.runtime,
  };
}
